import { ENDPOINTS } from "../utils/appConfig";
import { fetchWithAuthRetry, getAuthHeaders } from "../utils/helpers";

export async function sendVoiceCommand(commandText) {
  try {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const headers = {
      ...getAuthHeaders(),
      'X-User-Timezone': userTimezone,
    };
    const response = await fetchWithAuthRetry(ENDPOINTS.VOICE_COMMAND(commandText), {
      method: 'GET',
      headers: headers,
    });
    if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`);
    return await response.json();
  } catch (error) {
    console.error('Failed to send voice command:', error);
    if (error?.message?.includes('404')) {
      return [];
    }
    return null;
  }
}
